import { atom } from "recoil";

const carState =atom({
    key: 'car',
    default: ''
})

export default carState